<div id="content" class="flexColumnContainer">
  <div class="flexColumnContainer justifyContentSpaceBetween">
    <div #titleAndButtonContainer id="titleAndButtonContainer" class="flexRowContainer justifyContentSpaceBetween">
      <div #breadcrumbEl class="flexRowContainer breadcrumbContainer">
        <span class="breadcrumb parent" (click)="backToCasesOverview()" (keydown.enter)="backToCasesOverview()">
          {{ 'caseDetail.breadcrumb.cases' | translate }}
        </span>
        <mat-icon class="material-symbols-outlined breadcrumbIcon">chevron_right</mat-icon>
        <span class="breadcrumb current">
          {{ caseHal.name }}
        </span>
      </div>
      <div id="caseDetailButtonContainer" class="flexRowContainer">
        @if (caseHal._links.hasLink('disableAutomation') && !isButtonHidden('disableAutomation')) {
          <button id="disableAutomationButton" mat-stroked-button
                  (click)="openDisableAutomationModal()">
            <span>{{ 'caseDetail.buttons.deactivateAutomation.label' | translate }}</span>
          </button>
        }
        @if (!isAutomatedCase()) {
          <span>
          <!-- outer span takes on height of parent container, so nested span is required to show tooltip at correct vertical offset -->
            @if (showCaseRequestInformationButton() && !isButtonHidden('requestInformation')) {
              <span
                class="requestInformationTooltip"
                [matTooltip]="getRequestInformationTooltipKey() | translate"
                [matTooltipDisabled]="getRequestInformationTooltipKey()  === ''">
              <button mat-button (click)="requestInformation()"
                      [disabled]="!caseHal._links.hasLink('requestInformation')">
                <mat-icon class="material-symbols-outlined">forum</mat-icon>
                <span>{{ 'caseDetail.buttons.requestInformation.label' | translate }}</span>
              </button>
            </span>
            }
        </span>
          @if (caseHal._links.hasLink('sign') && !isButtonHidden('sign')) {
            <button mat-button (click)="startSignatureProcess()"
            >
              <mat-icon class="material-symbols-outlined">signature</mat-icon>
              <span>{{ 'caseDetail.buttons.startSignatureProcess.label' | translate }}</span>
            </button>
          }
          @if (caseHal._links.hasLink('onlineIdentification') && !isButtonHidden('onlineIdentification')) {
            <button id="onlineIdentificationButton" mat-button (click)="startOnlineIdentification()">
              <mat-icon class="material-symbols-outlined">person_search</mat-icon>
              <span>{{ 'caseDetail.buttons.onlineIdentification.label' | translate }}</span>
            </button>
          }
          @if (caseHal._links.hasLink('move') && !isButtonHidden('move')) {
            <button id="moveCaseButton" mat-button
                    (click)="openMoveCaseModal()">
              <mat-icon class="material-symbols-outlined">move_item</mat-icon>
              <span>{{ 'caseDetail.buttons.moveCase.label' | translate }}</span>
            </button>
          }
          @if (isCaseInProcessing() && !isButtonHidden('uploadCompletionDocument')) {
            <button id="uploadCompletionDocument" mat-button [disabled]="uploading || !canUploadDocuments()"
                    (click)="triggerCompletionDocumentUpload()">
              <mat-icon class="material-symbols-outlined">upload_file</mat-icon>
              <span>{{ 'caseDetail.buttons.uploadCompletionDocument.label' | translate }}</span>
            </button>
          }
          @if (hiddenButtons.size > 0) {
            <button mat-icon-button [matMenuTriggerFor]="overflowMenu">
              <mat-icon class="material-symbols-outlined">more_vert</mat-icon>
            </button>
            <mat-menu #overflowMenu="matMenu">
              @for (btn of hiddenMenuButtons; track btn.key) {
                <button mat-menu-item (click)="btn.action()" [disabled]="btn.disabled()">
                  @if (btn.icon) {
                    <mat-icon class="material-symbols-outlined">{{ btn.icon }}</mat-icon>
                  }
                  {{ btn.labelKey | translate }}
                </button>
              }
            </mat-menu>
          }
          @if (showResumeInformationCollectionCta()) {
            <!-- The tooltip sits on a wrapper because Material does not show one on a disabled button, and disabled is
                 exactly the state that needs the explanation. -->
            <span [matTooltip]="getResumeInformationCollectionTooltipKey() | translate">
              <button #resumeInformationCollectionButton id="resumeInformationCollection" mat-stroked-button
                      [disabled]="!caseHal._links.hasLink('resumeInformationCollection')"
                      (click)="confirmResumeInformationCollection()">
                <mat-icon class="material-symbols-outlined">undo</mat-icon>
                <span>{{ 'caseDetail.buttons.resumeInformationCollection.label' | translate }}</span>
              </button>
            </span>
          }
          @if (showConfirmCompletenessCta()) {
            <!-- The tooltip sits on a wrapper because Material does not show one on a disabled button, and disabled is
                 exactly the state that needs the explanation. -->
            <span [matTooltip]="getConfirmCompletenessTooltipKey() | translate">
              <button #completeCaseButton id="confirmCompleteness" mat-flat-button
                      [disabled]="!caseHal._links.hasLink('startProcessing')"
                      (click)="confirmCompleteness()">
                <mat-icon class="material-symbols-outlined">task_alt</mat-icon>
                <span>{{ 'caseDetail.buttons.confirmCompleteness.label' | translate }}</span>
              </button>
            </span>
          } @else {
            <button #completeCaseButton [disabled]="!caseHal._links.hasLink('completeCase')" mat-flat-button
                    (click)="completeCase()">
              <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
              <span>{{ 'caseDetail.buttons.completeCase.label' | translate }}</span>
            </button>
          }
        }
      </div>
    </div>
    <!-- Hidden measurement container for overflow calculation -->
    <div class="overflowMeasureContainer" aria-hidden="true">
      @for (btn of overflowButtons; track btn.key) {
        @if (btn.visible()) {
          @if (btn.buttonType === 'mat-stroked-button') {
            <button #measureButton [attr.data-key]="btn.key" mat-stroked-button>
              @if (btn.icon) {
                <mat-icon class="material-symbols-outlined">{{ btn.icon }}</mat-icon>
              }
              <span>{{ btn.labelKey | translate }}</span>
            </button>
          } @else {
            <button #measureButton [attr.data-key]="btn.key" mat-button>
              @if (btn.icon) {
                <mat-icon class="material-symbols-outlined">{{ btn.icon }}</mat-icon>
              }
              <span>{{ btn.labelKey | translate }}</span>
            </button>
          }
        }
      }
    </div>
    <div id="caseInformationRow" class="flexRowContainer justifyContentSpaceBetween">
      <div id="caseInformation" class="flexColumnContainer">
        @if (caseHal.state) {
          <span id="caseStateTag" class="documentTagRemake"
                [ngClass]="caseHal.state.toLowerCase()">{{ 'caseOverview.table.states.' + caseHal.state.toLowerCase() | translate }}</span>
        }
        @if (caseHal.description) {
          <span class="body-medium">{{ 'caseDetail.description' | translate }}
            : {{ caseHal.description }}</span>
        }
        @if (caseHal.reference) {
          <span class="body-medium">{{ 'caseDetail.reference' | translate }}
            : {{ caseHal.reference }}</span>
        }
        <span class="body-medium">
          {{ 'caseDetail.client' | translate }} : {{ caseHal.client }}
          @if (caseHal.clientAdditionalInfo) {
            <span> - </span>
            <app-additional-user-info
              [text]="caseHal.clientAdditionalInfo"></app-additional-user-info>
          }
        </span>
        <span class="body-medium">{{ 'caseDetail.creationDate' | translate }}
          : {{ caseHal.creationDate | date:'dd.MM.yyyy, HH:mm' }}</span>
        @if (caseHal.externalCaseId) {
          <span class="body-medium">{{ 'caseDetail.externalCaseId' | translate }}
            : {{ caseHal.externalCaseId }}</span>
        }
        @if (caseHal.assignee) {
          <span class="body-medium">{{ 'caseDetail.assignee' | translate }}
            : {{ caseHal.assignee }}</span>
        }
      </div>
      @if (caseHal.informationLink && isValidUrl(caseHal.informationLink)) {
        <a id="informationLink" [href]="caseHal.informationLink" target="_blank" rel="noopener noreferrer">
          <mat-icon class="material-symbols-outlined">arrow_outward</mat-icon>
          <span
            class="informationLinkLabel title-small">{{ caseHal.informationLinkLabel || ('caseDetail.informationLink' | translate) }}</span>
          @if (caseHal.informationLinkDate) {
            <span class="informationLinkSeparator" aria-hidden="true"></span>
            <span
              class="informationLinkDate body-medium">{{ caseHal.informationLinkDate | date:'dd.MM.yyyy, HH:mm' }}</span>
          }
        </a>
      }
    </div>
    @if (!loadingDocuments) {
      <span id="documentActionsContainer" class="flexRowContainer">
        <app-selection-actions-bar
          id="selectedDocumentsActions"
          selectionLabelKey="caseDetail.chosen"
          [selectedCount]="selectedDocuments.length"
          [reserveSpaceWhenEmpty]="true"
        >
          @if (!isAutomatedCase()) {
            <app-selection-action
              icon="delete"
              [tooltip]="'caseDetail.tooltips.deleteSelectedDocuments' | translate"
              [disabled]="!canAllDocumentsBeDeleted()"
              (actionTriggered)="deleteSelectedDocuments()">
            </app-selection-action>
          }
          <app-selection-action
            icon="download"
            [tooltip]="getDownloadSelectedDocumentsTooltipKey() | translate"
            [disabled]="!canSelectedDocumentsBeDownloaded()"
            (actionTriggered)="downloadSelectedDocuments()">
          </app-selection-action>
          @if (anyDocumentHasSealLink()) {
            <app-selection-action
              icon="verified"
              [tooltip]="getSealSelectedDocumentTooltipKey() | translate"
              [disabled]="!canSelectedDocumentBeSealed()"
              (actionTriggered)="sealSelectedDocument()">
            </app-selection-action>
          }
          @if (!isAutomatedCase()) {
            <app-selection-action
              icon="thumb_up"
              [tooltip]="(canSelectedDocumentsBeMarkedReady()
                ? 'caseDetail.buttons.setReadySelectedDocuments.tooltip'
                : 'caseDetail.buttons.setReadySelectedDocuments.disabledTooltip') | translate"
              [disabled]="!canSelectedDocumentsBeMarkedReady()"
              (actionTriggered)="markSelectedDocumentsAsReady()">
            </app-selection-action>
          }
        </app-selection-actions-bar>
        @if (!isAutomatedCase() && !isCaseInProcessing()) {
          <button id="addDocuments" mat-stroked-button [matMenuTriggerFor]="addDocumentsMenu"
                  [disabled]="!caseHal._links.hasLink('addDocuments')">
          <mat-icon class="material-symbols-outlined">add</mat-icon>
          <span class="label-large">{{ 'caseDetail.buttons.addDocument.label' | translate }}</span>
        </button>
          <mat-menu #addDocumentsMenu="matMenu">
          @if (caseHal._links.hasLink('addForms')) {
            <button mat-menu-item (click)="openAddFormsDialog()">
              <mat-icon class="material-symbols-outlined">library_add</mat-icon>
              {{ 'caseDetail.addDocument.menu.buttons.addForm' | translate }}
            </button>
          }
            <button mat-menu-item (click)="fileUpload.click()">
            <mat-icon class="material-symbols-outlined">upload_file</mat-icon>
              {{ 'caseDetail.addDocument.menu.buttons.uploadDocument' | translate }}
          </button>
        </mat-menu>
        }
      </span>
    }
  </div>
  <div id="pdfUploadContainer" (dragenter)="pdfUploadDragEnter()" (dragleave)="pdfUploadDragLeave($event)"
       class="flexColumnContainer selectable-table-container" appDragToUpload (fileDropped)="fileDropped($event)">
    <section id="tableContainer" class="selectable-table-content" [ngClass]="{'loading': loadingDocuments}">
      @if (loadingDocuments) {
        <div id="matSpinnerContainer">
          <mat-spinner id="loadingSpinner" [diameter]="50"></mat-spinner>
        </div>
      }
      <table class="selectable-table" mat-table [dataSource]="dataSource">
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

        <ng-container matColumnDef="selection">
          <th mat-header-cell *matHeaderCellDef>
            <app-table-selection-cell
              [checked]="areAllDocumentsSelected()"
              [indeterminate]="areSomeDocumentsSelected()"
              [disabled]="documentHals.length === 0"
              [ariaLabel]="'caseDetail.selection.selectAll' | translate:{selectedCount: selectedDocuments.length, totalCount: documentHals.length}"
              (toggled)="selectionChangeAll()"
            ></app-table-selection-cell>
          </th>
          <td mat-cell *matCellDef="let document">
            <app-table-selection-cell
              [row]="true"
              [checked]="selectedDocuments.includes(document.identification)"
              [ariaLabel]="('caseDetail.table.columns.document' | translate) + ': ' + document.title"
              (toggled)="selectionChanged(document.identification)"
            ></app-table-selection-cell>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>{{ 'caseDetail.table.columns.document' | translate }}</th>
          <td mat-cell *matCellDef="let document" id="nameCell"
              [ngClass]="{'clickableTableCell': isDocumentPreviewAvailable(document)}"
              (click)="navigateToDocumentPreview(document)" (keydown.enter)="navigateToDocumentPreview(document)">
            <div class="table-primary-cell-content">
              @if (document.formIdentifier && !document.hasFileId()) {
                <mat-icon
                  class="material-symbols-outlined mat-symbols-fill documentTableIcon">list_alt
                </mat-icon>
              }
              @if (document.hasFileId()) {
                <mat-icon
                  class="material-symbols-outlined mat-symbols-fill documentTableIcon">
                  file_present
                </mat-icon>
              }
              @if (!document.formIdentifier && !document.hasFileId()) {
                <mat-icon
                  class="material-symbols-outlined mat-symbols-fill documentTableIcon">
                  cloud_upload
                </mat-icon>
              }
              <div id="documentInfoContainer" class="flexColumnContainer">
                <span class="body-medium">{{ document.title }}</span>
                @if (isCompletionDocument(document)) {
                  <span class="documentTypeLabel body-small">{{ 'caseDetail.documentType.completionDocument' | translate }}</span>
                }
              </div>
              @if (isDocumentLocked(document)) {
                <mat-icon
                  class="material-symbols-outlined documentLockedBadge" role="img"
                  [attr.aria-label]="'caseDetail.tooltips.documentLocked' | translate"
                  [matTooltip]="'caseDetail.tooltips.documentLocked' | translate">lock
                </mat-icon>
              }
              @if (document.sealed) {
                <mat-icon
                  class="material-symbols-outlined mat-symbols-filled-rounded documentSealedBadge"
                  [matTooltip]="document.sealedDate && document.sealedBy
                    ? ('caseDetail.table.sealedBadgeDetailed' | translate:{ date: (document.sealedDate | date:'dd.MM.yyyy, HH:mm'), user: document.sealedBy })
                    : ('caseDetail.table.sealedBadge' | translate)">verified
                </mat-icon>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="state">
          <th mat-header-cell *matHeaderCellDef>{{ 'caseDetail.table.columns.state' | translate }}</th>
          <td mat-cell *matCellDef="let document" id="stateCell"
              [ngClass]="{'clickableTableCell': isDocumentPreviewAvailable(document)}"
              (click)="navigateToDocumentPreview(document)" (keydown.enter)="navigateToDocumentPreview(document)">
            <div class="flexColumnContainer">
              <span class="documentTagRemake"
                    [ngClass]="document.state.toLowerCase()">{{ 'caseDetail.table.states.' + document.state.toLowerCase() | translate }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastAction">
          <th mat-header-cell *matHeaderCellDef>{{ 'caseDetail.table.columns.lastAction' | translate }}</th>
          <td mat-cell *matCellDef="let document" id="lastActionCell"
              [ngClass]="{'clickableTableCell': isDocumentPreviewAvailable(document)}"
              (click)="navigateToDocumentPreview(document)" (keydown.enter)="navigateToDocumentPreview(document)">
            @if (document.lastAction; as lastAction) {
              <div class="flexColumnContainer lastActionContainer">
                @let label = 'caseDetail.table.lastAction.types.' + lastAction.type | translate;
                <span class="body-medium" [matTooltip]="label">{{ label }}</span>
                @if (lastAction.occurredAt) {
                  @let detail = (lastAction.occurredAt | date:'dd.MM.yyyy, HH:mm') + ' · '
                    + (lastAction.actorName || ('caseDetail.table.lastAction.actors.' + lastAction.actorType | translate));
                  <span class="body-small lastActionDetail" [matTooltip]="detail">{{ detail }}</span>
                }
              </div>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let document" id="actionsCell">
            <button mat-icon-button [matMenuTriggerFor]="documentActionsMenu">
              <mat-icon class="material-symbols-outlined">more_vert</mat-icon>
            </button>
            <mat-menu #documentActionsMenu="matMenu">
              @if (isDocumentPreviewAvailable(document)) {
                <button mat-menu-item (click)="navigateToDocumentPreview(document)"
                >
                  <mat-icon class="material-symbols-outlined">file_open</mat-icon>
                  {{ 'caseDetail.documentActions.buttons.open' | translate }}
                </button>
              }
              @if (document.formIdentifier && !document.hasFileId()) {
                <button disabled mat-menu-item>
                  <mat-icon class="material-symbols-outlined">visibility</mat-icon>
                  {{ 'caseDetail.documentActions.buttons.preview' | translate }}
                </button>
              }
              @if (document.hasFileId()) {
                <button mat-menu-item
                        (click)="downloadAndOpenSinglePdf(document)">
                  <mat-icon class="material-symbols-outlined">download</mat-icon>
                  {{ 'caseDetail.documentActions.buttons.download' | translate }}
                </button>
              }
              @if (document._links?.hasLink('delete')) {
                <button mat-menu-item (click)="deleteSingleDocument(document.identification)">
                  <mat-icon class="material-symbols-outlined">delete</mat-icon>
                  {{ 'caseDetail.documentActions.buttons.remove' | translate }}
                </button>
              }
              @if (document.hasFileId() && document.formIdentifier && document._links?.hasLink('restore')) {
                <button mat-menu-item
                        (click)="restoreDocument(document.identification)">
                  <mat-icon class="material-symbols-outlined">restore_page</mat-icon>
                  {{ 'caseDetail.documentActions.buttons.restore' | translate }}
                </button>
              }
            </mat-menu>
          </td>
        </ng-container>

        <tr id="tableRow" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </section>
    @if (!loadingDocuments && dataSource.data.length === 0) {
      <div id="noDocumentsContainer" appDragToUpload
           (fileDropped)="fileDropped($event)">
        <div id="noDocumentsContentContainer" class="flexColumnContainer">
          <mat-icon id="bigIcon" class="material-symbols-outlined">folder_open</mat-icon>
          <span id="noDocumentsTitle" class="title-small">{{ 'caseDetail.noDocuments.title' | translate }}</span>
          @if (canAddRegularDocuments()) {
            <span id="noDocumentsText" class="body-small">{{ 'caseDetail.noDocuments.text' | translate }}</span>
          }
          @if (caseHal._links.hasLink('addForms')) {
            <button mat-button (click)="openAddFormsDialog()">
              <mat-icon class="material-symbols-outlined">library_add</mat-icon>
              <span>{{ 'caseDetail.noDocuments.buttons.addForm' | translate }}</span>
            </button>
          }
          @if (caseHal._links.hasLink('addForms')) {
            <span id="noDocumentsOr"
                  class="body-small">{{ 'caseDetail.noDocuments.or' | translate }}</span>
          }
          @if (canAddRegularDocuments()) {
            <button mat-button (click)="fileUpload.click()">
              <mat-icon class="material-symbols-outlined">upload_file</mat-icon>
              <span>{{ 'caseDetail.noDocuments.buttons.uploadDocuments' | translate }}</span>
            </button>
          }
        </div>
      </div>
    }
  </div>
  @if (pagedDocumentHal._embedded?.documents?.length !== 0) {
    <mat-paginator
      [pageSize]="pagedDocumentHal.page.size"
      [pageIndex]="pagedDocumentHal.page.number"
      [length]="pagedDocumentHal.page.totalElements"
      [pageSizeOptions]="[5, 10, 20, 40]"
      (page)="updateDocumentsHal($event)"
    />
  }
  <input #fileUpload class="hidden" type="file" [disabled]="uploading || !canUploadDocuments()" (change)="fileSelected($event)" multiple>
</div>
